export default __webpack_public_path__ + "7f064f72edd2e382570d1bd0cf70c587.png";